import CLIENT from '../actionTypes';

import { AppAction } from '../../../types/app';
import { ClientAuthState } from '../types';

const initialState: ClientAuthState = {
  changePasswordReadyStatus: CLIENT.AUTH.CHANGE_PASSWORD.INVALID,
  changePasswordErr: null,
};

export default (
  state: ClientAuthState = initialState,
  action: AppAction = {}
): ClientAuthState => {
  switch (action.type) {
    case CLIENT.AUTH.CHANGE_PASSWORD.REQUESTING:
      return {
        ...state,
        changePasswordReadyStatus: action.type,
        changePasswordErr: null,
      };
    case CLIENT.AUTH.CHANGE_PASSWORD.FAILURE:
      return {
        ...state,
        changePasswordReadyStatus: action.type,
        changePasswordErr: action.err,
      };
    case CLIENT.AUTH.CHANGE_PASSWORD.SUCCESS:
      return {
        ...state,
        changePasswordReadyStatus: action.type,
        changePasswordErr: null,
      };
    default:
      return state;
  }
};
